import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'
import {DeleteModel} from '../Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const FdType = `${API_URL}/fixed-deposit-type`

export const service = {
  getFdType: (params: ParamsModel) => {
    return axios.get(FdType, {params})
  },

  getFdTypeList: () => {
    return axios.get(`${FdType}/list`)
  },

  addFdType: (data: any) => {
    return axios.post(FdType, data)
  },

  updateFdType: (body: any, id: string) => {
    return axios.patch(`${FdType}/${id}`, body)
  },

  deleteFdType: (data: DeleteModel) => {
    return axios.delete(FdType, {data})
  },
  singleActivateFdType: (id: any) => {
    return axios.patch(`${FdType}/enable`, id)
  },

  singleDeactivateFdType: (id: any) => {
    return axios.patch(`${FdType}/disable`, id)
  },

  sortFdType: (body: any) => {
    return axios.patch(`${FdType}/sort`, body)
  },
}
